<!-- Modal -->
<div class="modal fade" id="projectautomationmodal" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">{{ 'projectlist.automation' | trans }}</h5>
                <button type="button" (click)="autoReset()" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <app-loadconfirm *ngIf="showSpinner" [text]="'projectautomationaction.loadauto' | trans "
                    [icon]="'pending'"></app-loadconfirm>
                <!---Standard modal content--->
                <ng-container *ngIf="standard">
                    <div class="row">
                        <div class="col-10">
                            <p>{{ 'projectautomation.subheader' | trans }}</p>
                        </div>
                        <div class="col-2">
                            <label style="margin-top:-5px;" class="btn float-right btn-sm mb-0">
                                <p class="btn-text">{{ 'orgstyle.import' | trans }}</p>
                                <input type="file" accept="application/json" class="d-none"
                                    (change)="onImportFileSelected($event)">
                            </label>
                        </div>

                    </div>

                    <ul class="list-group">
                        <li *ngFor="let au of automationlist" class="list-group-item">

                            <div class="input-group">
                                <input type="text" class="form-control" name="automationlistname" readonly
                                    [value]="au.automationname">
                                <div class="input-group-append">
                                    <span class="input-group-text p-0" id="basic-addon2">
                                        <button class="btn bg-transparent action-btn p-0 pl-2 pr-2 rounded-circle"
                                            (click)="editAuto(au)">
                                            <p class="btn-text"></p>
                                            <span class="material-icons f-18 align-middle lh-30">
                                                create
                                            </span>
                                        </button>
                                        <button class="btn bg-transparent pl-2 pr-2 p-0 rounded-circle"
                                            (click)="deleteAuto(au)">
                                            <p class="btn-text"></p>
                                            <span class="material-icons f-18 align-middle lh-30">
                                                delete
                                            </span>
                                        </button>

                                    </span>
                                </div>
                            </div>
                        </li>
                        <li class="list-group-item">
                            <div class="input-group">
                                <input type="text" class="form-control"
                                    placeholder="{{ 'projectautomation.nameplace' | trans }}"
                                    aria-describedby="automationname" [(ngModel)]="newAutomationName">
                                <div class="input-group-append">
                                    <span class="input-group-text p-0" id="automationname">
                                        <button class="btn bg-transparent action-btn p-0 pl-2 pr-2 rounded-circle"
                                            (click)="createAuto()">
                                            <p class="btn-text"></p>
                                            <span class="material-icons f-18 align-middle lh-30">
                                                add
                                            </span>
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </ng-container>
                <!---Standard modal content--->
                <!---create modal content--->
                <ng-container *ngIf="create">
                    <form>
                        <div class="form-group">
                            <label for="automationname">{{ 'projectautomation.name' | trans }}</label>
                            <input type="text" class="form-control" id="automationname" name="automationname"
                                placeholder="{{ 'projectautomation.nameplace' | trans }}"
                                [(ngModel)]="modalAutomation.automationname">
                        </div>
                        <div class="form-group">
                            <label for="automationdesc">{{ 'projectautomation.desc' | trans }}</label>
                            <textarea class="form-control" id="automationdesc" [(ngModel)]="modalAutomation.description"
                                name="automationdesc"
                                placeholder="{{ 'projectautomation.descplace' | trans }}"></textarea>
                        </div>
                        <div class="form-group">
                            <label for="automationtrigger">{{ 'projectautomation.trigger' | trans }}</label>
                            <select *ngIf="automationType === 'projectautomation'" class="form-control"
                                id="automationtrigger" name="automationtrigger"
                                [(ngModel)]="modalAutomation.automationtriggerevent">
                                <option disabled hidden selected>{{ 'orgprojectadd.choose' | trans }}</option>
                                <option [ngValue]="'task.done'">Task Complete</option>
                                <option [ngValue]="'taskCreated'">Task Created</option>
                                <option [ngValue]="'taskUpdated'">Task Updated</option>
                                <option [ngValue]="'taskDeleted'">Task Deleted</option>
                                <option [ngValue]="'taskAssigned'">Task Assigned</option>
                                <option [ngValue]="'taskUnassigned'">Task Unassigned</option>
                                <option [ngValue]="'taskOverdue'">Task Overdue</option>
                                <option [ngValue]="'taskCommented'">Task Commented</option>
                                <option [ngValue]="'stageCreated'">Stage Created</option>
                                <option [ngValue]="'stageUpdated'">Stage Updated</option>
                                <option [ngValue]="'stageDeleted'">Stage Deleted</option>
                            </select>
                            <select *ngIf="automationType === 'organization'" class="form-control"
                                id="automationtrigger" name="automationtrigger"
                                [(ngModel)]="modalAutomation.automationtriggerevent">
                                <option disabled hidden selected>{{ 'orgprojectadd.choose' | trans }}</option>
                                <option [ngValue]="'form.submitted'">Form Submitted</option>
                                <option [ngValue]="'dealComplete'">deal Complete</option>
                                <option [ngValue]="'dealCreated'">deal Created</option>
                                <option [ngValue]="'dealUpdated'">deal Updated</option>
                                <option [ngValue]="'dealDeleted'">deal Deleted</option>
                                <option [ngValue]="'projectOverdue'">Project Overdue</option>
                                <option [ngValue]="'projectCreated'">Project Created</option>
                                <option [ngValue]="'projectUpdated'">Project Updated</option>
                                <option [ngValue]="'projectDeleted'">Project Deleted</option>
                            </select>
                        </div>
                        <div *ngIf="modalAutomation.automationtriggerevent == 'task.done'" class="form-group">

                            <label for="automationtriggercondition">{{ 'automationtriggercondition' | trans }}</label>
                            <input [(ngModel)]="modalAutomation.automationtriggercondition" type="text"
                                class="form-control" id="automationtriggercondition" name="automationtriggercondition"
                                placeholder="{{ 'automationtriggerconditionplaceholder' | trans }}">
                        </div>
                    </form>
                </ng-container>
                <!---create modal content--->
                <!---edit modal content--->
                <ng-container *ngIf="edit">
                    <form>
                        <div class="card mb-2 p-3 bg-secondary">
                            <div (click)="collapsemeta()" type="button" data-toggle="collapse"
                                data-target="#automationmetacollapse" class="d-inline-flex">
                                <p class="mb-0 align-middle lh-25 f-15">{{modalAutomation.automationname}} -
                                </p>
                                <p class="mb-0 f-13 lh-25 align-middle pl-2 mr-auto"> {{
                                    modalAutomation.description
                                    }}
                                </p>
                                <span *ngIf="collapsemetaboolean" class="material-icons float-right">
                                    keyboard_arrow_up
                                </span>
                                <span *ngIf="!collapsemetaboolean" class="material-icons float-right">
                                    keyboard_arrow_down
                                </span>
                            </div>

                            <div class="collapse pt-2" id="automationmetacollapse">

                                <div class="form-group">
                                    <label for="automationname">{{ 'projectautomation.name' | trans }}</label>
                                    <input type="text" class="form-control" id="automationname" name="automationname"
                                        [(ngModel)]="modalAutomation.automationname">
                                </div>
                                <div class="form-group">
                                    <label for="automationdesc">{{ 'projectautomation.desc' | trans }}</label>
                                    <textarea class="form-control" id="automationdesc" name="automationdesc"
                                        [(ngModel)]="modalAutomation.description"></textarea>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="automationtrigger">{{ 'projectautomation.trigger' | trans }}</label>
                            <select *ngIf="automationType === 'projectautomation'" class="form-control"
                                id="automationtrigger" name="automationtrigger"
                                [(ngModel)]="modalAutomation.automationtriggerevent">
                                <option disabled hidden selected>{{ 'orgprojectadd.choose' | trans }}</option>
                                <option [ngValue]="'task.done'">Task Complete</option>
                                <option [ngValue]="'taskCreated'">Task Created</option>
                                <option [ngValue]="'taskUpdated'">Task Updated</option>
                                <option [ngValue]="'taskDeleted'">Task Deleted</option>
                                <option [ngValue]="'taskAssigned'">Task Assigned</option>
                                <option [ngValue]="'taskUnassigned'">Task Unassigned</option>
                                <option [ngValue]="'taskOverdue'">Task Overdue</option>
                                <option [ngValue]="'taskCommented'">Task Commented</option>
                                <option [ngValue]="'stageCreated'">Stage Created</option>
                                <option [ngValue]="'stageUpdated'">Stage Updated</option>
                                <option [ngValue]="'stageDeleted'">Stage Deleted</option>
                            </select>
                            <select *ngIf="automationType === 'organization'" class="form-control"
                                id="automationtrigger" name="automationtrigger"
                                [(ngModel)]="modalAutomation.automationtriggerevent">
                                <option disabled hidden selected>{{ 'orgprojectadd.choose' | trans }}</option>
                                <option [ngValue]="'form.submitted'">Form Submitted</option>
                                <option [ngValue]="'deal.complete'">deal Complete</option>
                                <option [ngValue]="'deal.created'">deal Created</option>
                                <option [ngValue]="'deal.updated'">deal Updated</option>
                                <option [ngValue]="'deal.deleted'">deal Deleted</option>
                                <option [ngValue]="'project.overdue'">Project Overdue</option>
                                <option [ngValue]="'project.created'">Project Created</option>
                                <option [ngValue]="'project.updated'">Project Updated</option>
                                <option [ngValue]="'project.deleted'">Project Deleted</option>
                            </select>
                        </div>
                        <div *ngIf="modalAutomation.automationtriggerevent == 'task.done'" class="form-group">

                            <label for="automationtriggercondition">{{ 'automationtriggercondition' | trans }}</label>
                            <select [(ngModel)]="modalAutomation.automationtriggercondition" class="form-control"
                                id="automationtriggercondition" name="automationtriggercondition">
                                <option *ngFor="let condition of conditions" [ngValue]="condition.value">{{
                                    condition.viewValue }}</option>
                            </select>
                        </div>

                        <div class="form-group mb-0">
                            <label for="actionlist">Action list</label>
                            <div id="actionlist" *ngFor="let aa of modalAutomationActionList" class="mb-1">
                                <app-automationaction (setAutomationCollapse)="setAutomationCollapse($event)"
                                    [automationAction]="aa" [automation]="modalAutomation"
                                    [isOpen]="openActionId === aa.actionId"></app-automationaction>
                            </div>
                        </div>
                    </form>
                    <div class="input-group">
                        <input type="text" class="form-control"
                            placeholder="{{ 'projectautomation.nameplace' | trans }}" aria-describedby="automationname"
                            [(ngModel)]="newActionName">
                        <div class="input-group-append">
                            <span class="input-group-text p-0" id="automationname">
                                <button class="btn bg-transparent action-btn p-0 pl-2 pr-2 rounded-circle"
                                    (click)="createAction()">
                                    <p class="btn-text"></p>
                                    <span class="material-icons f-18 align-middle lh-30">
                                        add
                                    </span>
                                </button>

                            </span>
                        </div>
                    </div>


                </ng-container>
                <!---edit modal content--->
                <!---delete modal content--->
                <ng-container *ngIf="delete">
                    <p class="text-center f-15 pt-2">{{ 'projectautomation.confirmdelete' | trans }}
                        <b>{{modalAutomation.automationname}}?</b>
                    </p>
                    <div class="alert alert-danger">
                        {{ 'projectautomationaction.deletemodalwarning' | trans }}
                    </div>
                </ng-container>
                <!---delete modal content--->
            </div>
            <!---create footer--->
            <ng-container *ngIf="create">
                <div class="modal-footer">
                    <button class="btn-close" type="button" (click)="autoReset()" data-dismiss="modal">
                        <p class="btn-save-text">{{ 'projectstage.cancel' | trans }}</p>
                    </button>
                    <button class="btn-save" (click)="postNewAuto()">
                        <p class="btn-save-text">{{ 'projectautomation.createautomation' | trans }}</p>
                    </button>


                </div>
            </ng-container>
            <!---create footer end--->
            <!---edit footer--->
            <ng-container *ngIf="edit">
                <div class="modal-footer">
                    <button [disabled]="collapseactionboolean" class="btn-close" type="button" (click)="autoReset()"
                        data-dismiss="modal">
                        <p class="btn-save-text">{{ 'projectassign.cancel' | trans }}</p>
                    </button>
                    <button [disabled]="collapseactionboolean" class="btn-save" (click)="putAuto(modalAutomation)">
                        <p class="btn-save-text">{{ 'projectstage.savechanges' | trans }}</p>
                    </button>
                    <!-- EXPORT -->
                    <button type="button" class="btn" (click)="onExportAutomation()"
                        [disabled]="!modalAutomation?.automationId">
                        <p class="btn-text">{{ 'orgstyle.export' | trans }}</p>
                    </button>


                </div>
            </ng-container>
            <!---edit footer end--->
            <!---delete footer--->
            <ng-container *ngIf="delete">
                <div class="modal-footer">
                    <button class="btn-save" type="button" (click)="autoReset()" data-dismiss="modal"
                        aria-label="Close">
                        <p class="btn-save-text">{{ 'projectstage.cancel' | trans }}</p>
                    </button>
                    <button class="btn-close" type="button" (click)="deleteAutoConfirm()">
                        <p class="btn-save-text">{{ 'projectlist.delete' | trans }}</p>
                    </button>
                </div>
            </ng-container>
            <!---delete footer end--->
        </div>
    </div>
</div>